module.exports = __webpack_public_path__ + "static/media/p_bangcl.5598af9b.png";